import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrganisations = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".aorg{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("rect", {
			className: "aorg",
			x: 4.5,
			y: 8.161,
			width: 3,
			height: 9
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "aorg",
			x: 10.5,
			y: 8.161,
			width: 3,
			height: 9
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "aorg",
			x: 16.5,
			y: 8.161,
			width: 3,
			height: 9
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "aorg",
			d: "M21,20.161H3v-2.25a.75.75,0,0,1,.75-.75h16.5a.75.75,0,0,1,.75.75Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "aorg",
			x1: 1.5,
			y1: 23.161,
			x2: 22.5,
			y2: 23.161
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "aorg",
			x1: 1.5,
			y1: 20.161,
			x2: 22.5,
			y2: 20.161
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "aorg",
			d: "M21,5.161v2.25a.75.75,0,0,1-.75.75H3.75A.75.75,0,0,1,3,7.411V5.161L11.665.829a.752.752,0,0,1,.67,0Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "aorg",
			x1: 3,
			y1: 5.161,
			x2: 21,
			y2: 5.161
		})
	]
});
const ForwardRef = forwardRef(SvgOrganisations);
export default ForwardRef;
